var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConstructionSiteFlatline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    "data-imageid": "construction-site-flatline",
    imageName: "Construction site",
    className: "illustrations_image",
    style: {
      width: 188
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_30",
    "data-name": "#30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.84,192.64a.48.48,0,0,1-.41-.21,13.15,13.15,0,0,0-17-3.58.51.51,0,0,1-.45,0,.52.52,0,0,1-.3-.33,15.1,15.1,0,0,0-16.37-10.44.52.52,0,0,1-.58-.51c.11-4.84-4.27-8.68-7.95-11.05a58.51,58.51,0,0,0-23.16-8.65c-3.32-.48-14.48-1.46-18.64,6a.51.51,0,0,1-.68.2c-6-3.26-11.22-4.63-16-4.21-5.94.54-11.1,4.31-12.54,9.19-.06.19-.11.37-.16.56a5.65,5.65,0,0,1-1.17,2.56A5.88,5.88,0,0,1,61,173.57l-.73.28a8.05,8.05,0,0,0-4.75,8.05.5.5,0,0,1-.44.55.49.49,0,0,1-.55-.44,9.1,9.1,0,0,1,5.35-9.09l.78-.29a5,5,0,0,0,2-1.09,4.88,4.88,0,0,0,.94-2.14c.05-.19.1-.39.16-.58,1.56-5.26,7.07-9.34,13.41-9.9,4.9-.44,10.19.9,16.17,4.09,4.65-7.57,16-6.59,19.41-6.09a59.48,59.48,0,0,1,23.56,8.8c5.33,3.43,8.23,7.34,8.41,11.33a16.23,16.23,0,0,1,16.73,10.63,14.23,14.23,0,0,1,17.82,4.18.49.49,0,0,1-.13.69A.47.47,0,0,1,178.84,192.64Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.27,
    y: 51.96,
    width: 112.46,
    height: 3.8,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.73,56.26H218.27a.5.5,0,0,1-.5-.5V52a.5.5,0,0,1,.5-.5H330.73a.5.5,0,0,1,.5.5v3.8A.5.5,0,0,1,330.73,56.26Zm-112-1H330.23v-2.8H218.77Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.27,
    y: 63.79,
    width: 112.46,
    height: 3.8,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.73,68.09H218.27a.5.5,0,0,1-.5-.5v-3.8a.5.5,0,0,1,.5-.5H330.73a.5.5,0,0,1,.5.5v3.8A.5.5,0,0,1,330.73,68.09Zm-112-1H330.23v-2.8H218.77Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.3,
    y: 43.32,
    width: 9.54,
    height: 34.49,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.83,78.31H214.3a.5.5,0,0,1-.5-.5V43.32a.5.5,0,0,1,.5-.5h9.53a.5.5,0,0,1,.5.5V77.81A.5.5,0,0,1,223.83,78.31Zm-9-1h8.53V43.82H214.8Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.77,
    y: 43.32,
    width: 5.28,
    height: 34.49,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261,78.31h-5.27a.5.5,0,0,1-.5-.5V43.32a.5.5,0,0,1,.5-.5H261a.5.5,0,0,1,.5.5V77.81A.5.5,0,0,1,261,78.31Zm-4.77-1h4.27V43.82h-4.27Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.96,
    y: 43.32,
    width: 9.54,
    height: 34.49,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.5,78.31H326a.5.5,0,0,1-.5-.5V43.32a.5.5,0,0,1,.5-.5h9.54a.51.51,0,0,1,.5.5V77.81A.5.5,0,0,1,335.5,78.31Zm-9-1H335V43.82h-8.54Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.74,43.12a.5.5,0,0,1-.5-.5V40.06a.5.5,0,0,1,1,0v2.56A.5.5,0,0,1,217.74,43.12Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.51,43.12a.5.5,0,0,1-.5-.5V40.06a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2.56A.5.5,0,0,1,221.51,43.12Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.88,43.12a.5.5,0,0,1-.5-.5V40.06a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2.56A.5.5,0,0,1,328.88,43.12Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.66,43.12a.5.5,0,0,1-.5-.5V40.06a.5.5,0,0,1,1,0v2.56A.5.5,0,0,1,332.66,43.12Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.97,
    y: 199.42,
    width: 9.52,
    height: 49.93,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.49,249.85H254a.5.5,0,0,1-.5-.5V199.42a.51.51,0,0,1,.5-.5h9.52a.5.5,0,0,1,.5.5v49.93A.5.5,0,0,1,263.49,249.85Zm-9-1H263V199.92h-8.52Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.26,
    y: 199.42,
    width: 9.52,
    height: 49.93,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.77,249.85h-9.51a.5.5,0,0,1-.5-.5V199.42a.5.5,0,0,1,.5-.5h9.51a.5.5,0,0,1,.5.5v49.93A.5.5,0,0,1,321.77,249.85Zm-9-1h8.51V199.92h-8.51Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.2,
    y: 146.57,
    width: 41.2,
    height: 46.28,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.39,193.35H310.2a.5.5,0,0,1-.5-.5V146.57a.5.5,0,0,1,.5-.5h41.19a.5.5,0,0,1,.5.5v46.28A.5.5,0,0,1,351.39,193.35Zm-40.69-1h40.19V147.07H310.7Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.01,
    y: 146.57,
    width: 113.25,
    height: 46.28,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.26,193.35H197a.5.5,0,0,1-.5-.5V146.57a.5.5,0,0,1,.5-.5H310.26a.5.5,0,0,1,.5.5v46.28A.5.5,0,0,1,310.26,193.35Zm-112.75-1H309.76V147.07H197.51Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.54,
    y: 77.34,
    width: 41.25,
    height: 69.12,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.79,147H301.54a.5.5,0,0,1-.5-.5V77.34a.5.5,0,0,1,.5-.5h41.25a.5.5,0,0,1,.5.5v69.12A.5.5,0,0,1,342.79,147ZM302,146h40.25V77.84H302Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.63,193.63H54.07a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H370.63a.5.5,0,0,1,.5.5A.5.5,0,0,1,370.63,193.63Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.94,87.28s17.27,36.64,19.58,41.93-7.93,17.53-11.9,14.55S133.94,87.28,133.94,87.28Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.24,243s-.68,4.43.34,6.14A18.26,18.26,0,0,1,97,257a8.87,8.87,0,0,1-6.48,2.95c-4.09,0-8.18-3.07-8.64-4.54s3.3-17.16,3.3-17.16Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.49,260.44c-4.39,0-8.6-3.22-9.11-4.9-.47-1.53,2.65-14.78,3.28-17.42a.53.53,0,0,1,.28-.34.49.49,0,0,1,.44,0l9.09,4.77a.49.49,0,0,1,.26.52c-.18,1.18-.48,4.53.28,5.8a18.47,18.47,0,0,1,2.45,8,.46.46,0,0,1-.11.37A9.25,9.25,0,0,1,90.49,260.44Zm-5-21.46c-1.74,7.34-3.41,15.37-3.16,16.27.38,1.21,4.27,4.19,8.16,4.19a8.4,8.4,0,0,0,6-2.62,17.41,17.41,0,0,0-2.29-7.42c-.94-1.57-.61-5-.45-6.11Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129,143.54,109.29,149l-4.56-56.94S121,88.2,125,90,129,143.54,129,143.54Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.29,149.5a.62.62,0,0,1-.29-.09.51.51,0,0,1-.21-.37L104.23,92.1a.48.48,0,0,1,.38-.52c.67-.16,16.51-3.89,20.57-2s4.29,45.3,4.3,54a.49.49,0,0,1-.37.48l-19.69,5.46Zm-4-57,4.48,55.91,18.74-5.19c0-24.81-1.36-51.62-3.72-52.7C121.36,88.9,107.81,91.87,105.26,92.45Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.42,233.77V247.1l6.36,1.82-.15-2.73,2.88,2.88s17.09,3.07,17,.8-1.82-3.53-4-4.66c-2.31-1.22-8.4-4.66-8.4-4.66l-.91-9.77",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.33,251.19a99.18,99.18,0,0,1-13.91-1.63.47.47,0,0,1-.27-.14l-2-1.95.08,1.42a.49.49,0,0,1-.19.42.48.48,0,0,1-.45.09l-6.36-1.82a.5.5,0,0,1-.36-.48V233.77a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v12.95l5.32,1.53-.11-2a.5.5,0,0,1,.85-.38l2.77,2.77c7.32,1.3,15.59,2.14,16.27,1.23-.09-1.89-1.55-3.05-3.72-4.19s-8.36-4.63-8.42-4.67a.48.48,0,0,1-.25-.39l-.91-9.77a.49.49,0,0,1,.45-.54.52.52,0,0,1,.55.45l.88,9.51c1.13.64,6.14,3.46,8.17,4.52s4.14,2.53,4.24,5.09a.89.89,0,0,1-.34.75C148.18,251,146.94,251.19,145.33,251.19Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.87,148.92,80,242.1s.5,3.7,8.53,4.16,7.22-1.43,7.22-1.43l19.1-66.21L120,237.55l17.34,1.07-3.45-96.92Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.91,246.83c-.72,0-1.51,0-2.37-.08-8.34-.47-9-4.41-9-4.58V242l11.83-93.18a.51.51,0,0,1,.41-.43l42.07-7.22a.47.47,0,0,1,.39.1.5.5,0,0,1,.19.37l3.44,96.92a.43.43,0,0,1-.15.37.47.47,0,0,1-.37.14L120,238a.49.49,0,0,1-.46-.45l-4.92-56.27L96.3,244.85a1.08,1.08,0,0,1-.19.75C95.53,246.42,93.82,246.83,90.91,246.83Zm-10.37-4.75c.11.41,1.12,3.29,8.06,3.68,5,.28,6.3-.37,6.62-.66.08-.07.1-.12.1-.13a.34.34,0,0,1,0-.28l19.1-66.21a.51.51,0,0,1,.53-.36.49.49,0,0,1,.45.45l5.11,58.51,16.36,1-3.41-95.8-41.14,7.06Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.41,84.9s6.18,65.54,3.15,69.48S95,163.54,88.91,158.69s-4.76-54.68-2-58.92C94.44,93.43,108.41,84.9,108.41,84.9Z",
    fill: "#ff663b",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.94,87.28S146.83,151,145,152.79s-14.36,5.68-17.09,3.86-8.65-69.55-8.65-69.55S130,84,133.94,87.28Z",
    fill: "#ff663b",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.9,82.27l2.4,8s.06,4-5.67,4.33S107,91.53,107,91.53L103,76.45s1.49-5.83-2.33-14.06c0,0,7.83-1,17.09-2.75,0,0,3.82,11.48,4.45,15.81S117.9,82.27,117.9,82.27Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.79,95.12c-5.31,0-7.17-3.2-7.25-3.35a.36.36,0,0,1,0-.11l-3.94-15.09a.53.53,0,0,1,0-.25s1.39-5.77-2.3-13.72a.49.49,0,0,1,.39-.7c.08,0,7.92-1,17.06-2.75a.49.49,0,0,1,.57.33c.15.47,3.83,11.57,4.47,15.89.58,4-3,6.44-4.25,7.14l2.28,7.61a.68.68,0,0,1,0,.14s0,4.45-6.14,4.83Zm-6.35-3.79c.26.42,2.14,3.08,7.16,2.77,4.83-.31,5.17-3.28,5.2-3.77l-2.38-7.92a.5.5,0,0,1,.26-.59s4.65-2.39,4.08-6.3-3.61-13.22-4.3-15.31c-7.45,1.41-14,2.32-16,2.59,3.24,7.4,2.3,12.73,2.11,13.64Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.27,75.84S94.39,69.51,95.12,65s9.12-2,9.12-2,1.65,10.91,0,13.89S100.27,75.84,100.27,75.84Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.83,78.53c-1.48,0-2.72-2-3-2.39-.56-.61-6-6.67-5.24-11.2a3.27,3.27,0,0,1,1.52-2.32c2.71-1.68,8-.11,8.23,0a.48.48,0,0,1,.35.4c.07.45,1.66,11.12,0,14.21a2.17,2.17,0,0,1-1.84,1.34ZM99.55,62.84a5.56,5.56,0,0,0-2.87.63,2.19,2.19,0,0,0-1.06,1.63c-.69,4.2,5,10.34,5,10.41a.28.28,0,0,1,.06.09c.43.75,1.39,1.94,2.13,1.94h0c.34,0,.67-.29,1-.83,1.25-2.25.46-10,0-13.26A17.62,17.62,0,0,0,99.55,62.84Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.43,75.24a3.62,3.62,0,0,0-1.76-1.49,6.27,6.27,0,0,0-2.15-.37,2.79,2.79,0,0,0-1.19.15,2.09,2.09,0,0,0-.67.51,2.8,2.8,0,0,0-.87,1.75,3.27,3.27,0,0,0,.4,1.54,6.47,6.47,0,0,0,.91,1.49,4.42,4.42,0,0,0,6.27.48",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.46,80.88h-.36a5,5,0,0,1-3.38-1.72,7,7,0,0,1-1-1.61,3.7,3.7,0,0,1-.45-1.78,3.26,3.26,0,0,1,1-2.07,2.57,2.57,0,0,1,.83-.62,3.26,3.26,0,0,1,1.4-.19,7,7,0,0,1,2.33.4,4.16,4.16,0,0,1,2,1.7.5.5,0,0,1-.86.52,3.12,3.12,0,0,0-1.51-1.29,5.87,5.87,0,0,0-2-.33,2.3,2.3,0,0,0-1,.11,1.62,1.62,0,0,0-.51.4,2.3,2.3,0,0,0-.73,1.42,3,3,0,0,0,.35,1.31,6.49,6.49,0,0,0,.84,1.38,4,4,0,0,0,2.7,1.37,3.92,3.92,0,0,0,2.86-1,.51.51,0,0,1,.71,0,.49.49,0,0,1,0,.7A4.93,4.93,0,0,1,103.46,80.88Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.42,69s4.2,3.16,3.79,4.1-2.4,1.12-2.4,1.12",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.81,74.74a.5.5,0,0,1-.5-.46.5.5,0,0,1,.45-.54c.69-.06,1.8-.36,2-.81,0-.41-1.72-2.07-3.63-3.51a.5.5,0,1,1,.6-.8c2.06,1.55,4.42,3.62,4,4.7s-2.59,1.39-2.82,1.41Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.31,
    cy: 68.15,
    rx: 0.72,
    ry: 1.02,
    transform: "translate(-18.91 69.19) rotate(-31.47)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 117.87,
    cy: 66.59,
    rx: 0.72,
    ry: 1.02,
    transform: "translate(-17.42 71.34) rotate(-31.47)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.41,75.92l-3.67.89s.23,2.72,2.32,2.85S119.41,75.92,119.41,75.92Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.16,80.17H118c-2-.13-2.69-2.22-2.78-3.31a.49.49,0,0,1,.38-.52l3.66-.9a.53.53,0,0,1,.39.07.48.48,0,0,1,.22.33c0,.27.48,2.69-.49,3.79A1.61,1.61,0,0,1,118.16,80.17Zm-1.85-3c.14.67.57,1.9,1.78,2a.6.6,0,0,0,.57-.2,3.69,3.69,0,0,0,.33-2.42Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.9,82.27s-4.18,1.15-6.44.55c0,0,2.93,4.33,7.81,4.28Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.19,87.6c-5,0-8-4.32-8.14-4.5a.5.5,0,0,1,.54-.76c2.1.56,6.14-.54,6.18-.55a.49.49,0,0,1,.61.34L119.75,87a.48.48,0,0,1-.09.43.46.46,0,0,1-.39.2Zm-6.53-4.12a9.42,9.42,0,0,0,5.94,3.1l-1-3.71A20.36,20.36,0,0,1,112.66,83.48Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,181.69H115a.5.5,0,0,1-.41-.57c0-.21,3.4-21.12,3.18-24.89a.49.49,0,0,1,.47-.52.5.5,0,0,1,.52.47c.23,3.87-3,24.23-3.18,25.1A.51.51,0,0,1,115,181.69Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.06,166.17a.51.51,0,0,1-.4-.2.5.5,0,0,1,.1-.7,30.84,30.84,0,0,1,4.7-3.12.49.49,0,0,1,.65.25.5.5,0,0,1-.25.66,32.29,32.29,0,0,0-4.5,3A.49.49,0,0,1,97.06,166.17Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.56,164.64a.59.59,0,0,1-.26-.07l-6.13-3.68a.5.5,0,0,1,.51-.86l6.13,3.68a.5.5,0,0,1-.25.93Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.85,56.26l-5,1.06A12.71,12.71,0,0,0,94,65.55l16.48-3.49v0l13-2.75a1.57,1.57,0,0,0-.65-3.08Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,66.05a.54.54,0,0,1-.28-.08.49.49,0,0,1-.21-.32,13.21,13.21,0,0,1,24.61-8.9l4.62-1a2.08,2.08,0,0,1,1.56.29,2.07,2.07,0,0,1,.61,2.87,2,2,0,0,1-1.31.9l-13,2.75h-.17L94.1,66ZM106.45,50.7A12.22,12.22,0,0,0,94.39,65l16-3.38h.18l12.83-2.72a1.06,1.06,0,0,0,.83-1.27,1.08,1.08,0,0,0-.46-.68,1.1,1.1,0,0,0-.81-.15h0l-5,1.06a.5.5,0,0,1-.55-.27A12.21,12.21,0,0,0,106.45,50.7Zm16.4,5.56h0Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.85,57.32c-.46-.14-18,3.59-18,3.59",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.86,61.41a.51.51,0,0,1-.49-.4.49.49,0,0,1,.38-.59c17.67-3.75,18.08-3.62,18.24-3.58a.51.51,0,0,1,.34.62.52.52,0,0,1-.54.36c-.88,0-11.11,2.15-17.83,3.57Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.2,56.81a10.49,10.49,0,0,0-5-6.06",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.2,57.31a.48.48,0,0,1-.48-.35A10,10,0,0,0,103,51.18a.49.49,0,0,1-.2-.67.48.48,0,0,1,.67-.2,10.9,10.9,0,0,1,5.21,6.36.49.49,0,0,1-.33.62A.36.36,0,0,1,108.2,57.31Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,56.23a15.21,15.21,0,0,0-4.2-6",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,56.73a.48.48,0,0,1-.46-.32,14.89,14.89,0,0,0-4.07-5.83.5.5,0,1,1,.65-.75,15.86,15.86,0,0,1,4.35,6.22.5.5,0,0,1-.29.65Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.16,154.52a.51.51,0,0,1-.5-.49c0-.34-.89-34.06-1.32-42.77a131.82,131.82,0,0,0-1.76-15.81.5.5,0,0,1,.4-.58.51.51,0,0,1,.59.4,135.14,135.14,0,0,1,1.77,15.94c.43,8.73,1.31,42.45,1.32,42.79a.5.5,0,0,1-.49.52Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.49,142.17a.5.5,0,0,1-.06-1c.16,0,15.84-1.78,20.55-4.35a.49.49,0,0,1,.68.2.51.51,0,0,1-.2.68c-4.88,2.66-20.26,4.39-20.92,4.46Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.56,147.9a.5.5,0,0,1-.49-.43c-2.62-18.3-9.52-57-9.59-57.37a.5.5,0,0,1,.4-.58.51.51,0,0,1,.58.41c.07.39,7,39.08,9.6,57.4a.52.52,0,0,1-.43.57Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.94,136.88a.49.49,0,0,1-.48-.41.5.5,0,0,1,.39-.59l13.23-2.64a.5.5,0,1,1,.19,1L128,136.87Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.88,99.77s-26.8,39.36-13.73,50.28c12,10,38.48-6.62,38.48-6.62L110,129.37s-23.31,11.07-23.65,5.79c-.5-7.77,3.2-10.69,3.2-10.69Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109,114.42l2.31,48s38.62,11.81,50.85-6.38l3.4-49.85S131.12,119.71,109,114.42Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.47,166.65c-1.42,0-2.88-.05-4.39-.14a102.16,102.16,0,0,1-21-3.65.49.49,0,0,1-.35-.45l-2.31-48a.49.49,0,0,1,.18-.41.48.48,0,0,1,.43-.1c21.75,5.19,55.92-8.12,56.26-8.25a.49.49,0,0,1,.48.06.51.51,0,0,1,.21.44L162.62,156a.44.44,0,0,1-.08.25C158,163.1,149,166.65,136.47,166.65ZM111.75,162c3.8,1.09,38.52,10.47,49.88-6.17L165,106.9a174.15,174.15,0,0,1-19.3,5.86c-10.23,2.45-24.73,4.82-36.17,2.3Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.77,134.16A6.6,6.6,0,0,1,106,131a6.47,6.47,0,0,1,1.35-1.86,30.52,30.52,0,0,1,3-2.76,4.33,4.33,0,0,1,3.36-1.27,7.27,7.27,0,0,1-2.91,4.38,4,4,0,0,1,1.85-1.19c.49-.15,1.15-.12,1.36.34a1.2,1.2,0,0,1-.12.92,7.92,7.92,0,0,1-2.53,3.09l1.18-.72a2.39,2.39,0,0,1,1-.43.85.85,0,0,1,.9.46,1.09,1.09,0,0,1-.08.79,3.93,3.93,0,0,1-1.46,1.76,3.37,3.37,0,0,1,1.47-.69,1.16,1.16,0,0,1,1.29.78,1.39,1.39,0,0,1-.18.86c-.87,1.68-3,1.87-4,3.28-.75,1.06-.4,2.19-1.94,2.83C105.79,143.15,106,136.36,105.77,134.16Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.55,142.31a2.08,2.08,0,0,1-1.17-.34c-1.71-1.07-1.91-4.47-2-6.72,0-.4,0-.76-.07-1a7,7,0,0,1,.28-3.41,6.57,6.57,0,0,1,1.45-2,30.57,30.57,0,0,1,3.09-2.82c1-.79,2.33-1.66,3.78-1.36a.5.5,0,0,1,.31.22.47.47,0,0,1,.07.38,7.73,7.73,0,0,1-1,2.5h0a1.31,1.31,0,0,1,1.28.72,1.6,1.6,0,0,1-.12,1.33,9.23,9.23,0,0,1-.69,1.23,1.31,1.31,0,0,1,1.24.77,1.64,1.64,0,0,1-.09,1.18l-.18.37a1.6,1.6,0,0,1,1.51,1.18,1.79,1.79,0,0,1-.23,1.19,5.3,5.3,0,0,1-2.32,2.06A5.05,5.05,0,0,0,112,139a3.58,3.58,0,0,0-.45,1,2.79,2.79,0,0,1-1.71,2A3.34,3.34,0,0,1,108.55,142.31Zm4.58-16.74a4.78,4.78,0,0,0-2.42,1.2,29.58,29.58,0,0,0-3,2.72,5.9,5.9,0,0,0-1.25,1.7,6.24,6.24,0,0,0-.2,2.93h0c0,.29,0,.66.07,1.08.1,1.79.29,5.12,1.57,5.93a1.6,1.6,0,0,0,1.51,0,1.82,1.82,0,0,0,1.14-1.4,4.41,4.41,0,0,1,.59-1.26,5.78,5.78,0,0,1,2-1.57,4.38,4.38,0,0,0,1.92-1.65.89.89,0,0,0,.14-.53c0-.26-.44-.41-.74-.39a2.78,2.78,0,0,0-1.13.53l-.13.09a.5.5,0,0,1-.69-.14.51.51,0,0,1,.13-.69l.12-.08a3.45,3.45,0,0,0,1.16-1.46c.11-.25.11-.37.08-.42a.36.36,0,0,0-.37-.14,2.14,2.14,0,0,0-.78.35l-1.18.73a.5.5,0,0,1-.55-.83,7.4,7.4,0,0,0,2.36-2.9c.12-.25.16-.42.12-.5s-.42-.17-.75-.07a3.43,3.43,0,0,0-.76.33,6.53,6.53,0,0,1-1,.79.49.49,0,0,1-.66-.07.5.5,0,0,1,0-.66,4.51,4.51,0,0,1,1-.85A6.94,6.94,0,0,0,113.13,125.57Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.59,127.42c-.14-2-.77-4.29-2.55-5.31a3.8,3.8,0,0,0-3.6-.07.72.72,0,0,0-.44.46c-.07.31.23.58.51.75a6.79,6.79,0,0,0,1.88.8,2.61,2.61,0,0,0-2.61,1.51,4.07,4.07,0,0,0,2.58,1.38,1.75,1.75,0,0,0-1.83.64c-.65.92-.13,1.17.59,1.72a1.68,1.68,0,0,0-.94.09.83.83,0,0,0-.49.77c.06.59.8.77,1.31,1.07a2.06,2.06,0,0,1,.89,1.08,4,4,0,0,0,.25.74c1,1.76,3.27.29,3.81-.94A10.24,10.24,0,0,0,167.59,127.42Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.46,134.36a2,2,0,0,1-1.75-1.06,2.43,2.43,0,0,1-.23-.61l-.06-.22a1.53,1.53,0,0,0-.67-.81l-.35-.17c-.48-.23-1.14-.55-1.21-1.29a1.33,1.33,0,0,1,.77-1.26h0c-.28-.39-.37-.9.17-1.65a2,2,0,0,1,.42-.45,4.56,4.56,0,0,1-1.15-1,.49.49,0,0,1-.08-.53,3,3,0,0,1,1.35-1.44l-.43-.24c-.78-.48-.79-1-.73-1.29a1.27,1.27,0,0,1,.7-.8,4.34,4.34,0,0,1,4.08.09c2.06,1.18,2.66,3.76,2.8,5.71h0a10.84,10.84,0,0,1-.68,4.93,3.68,3.68,0,0,1-2.83,2Zm-2.69-4.59a1,1,0,0,0-.38.07c-.11.06-.21.18-.2.27s.28.3.65.48l.41.2a2.55,2.55,0,0,1,1.11,1.35c0,.1.06.19.08.29a2.25,2.25,0,0,0,.13.37,1,1,0,0,0,1,.56,2.72,2.72,0,0,0,2-1.45,10,10,0,0,0,.6-4.45c-.13-1.71-.63-3.95-2.31-4.92a3.32,3.32,0,0,0-3.12-.06.49.49,0,0,0-.19.13,3.09,3.09,0,0,0,.28.21,6.36,6.36,0,0,0,1.76.75.49.49,0,0,1,.36.57.5.5,0,0,1-.54.41,2.09,2.09,0,0,0-2,.93,3.6,3.6,0,0,0,2,1h0a.51.51,0,0,1,.44.56.52.52,0,0,1-.56.44h0c-.69-.09-1.07,0-1.35.42s-.31.45.3.9l.19.15a.49.49,0,0,1,.15.59.5.5,0,0,1-.53.3Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.68,110.19a.49.49,0,0,1-.48-.36.51.51,0,0,1,.34-.62l16.21-4.63a.5.5,0,1,1,.27,1l-16.2,4.63A.36.36,0,0,1,90.68,110.19Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.42,101.59a.5.5,0,0,1,0-1L135,99.27a.5.5,0,0,1,.11,1l-11.58,1.32Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.81,
    y: 77.34,
    width: 94.85,
    height: 69.12,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.66,147H206.81a.5.5,0,0,1-.5-.5V77.34a.5.5,0,0,1,.5-.5h94.85a.5.5,0,0,1,.5.5v69.12A.5.5,0,0,1,301.66,147Zm-94.35-1h93.85V77.84H207.31Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.7,
    y: 204.96,
    width: 84.43,
    height: 25.34,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.13,230.8H244.7a.5.5,0,0,1-.5-.5V205a.5.5,0,0,1,.5-.5h84.43a.5.5,0,0,1,.5.5V230.3A.5.5,0,0,1,329.13,230.8Zm-83.93-1h83.43V205.46H245.2Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.2 230.3 262.26 230.3 246.26 204.96 259.21 204.96 275.2 230.3",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.21,230.8H262.26a.52.52,0,0,1-.43-.23l-16-25.34a.49.49,0,0,1,0-.51.51.51,0,0,1,.44-.26h12.95a.5.5,0,0,1,.42.23l16,25.35a.5.5,0,0,1-.42.76Zm-12.68-1H274.3l-15.37-24.34H247.16Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "301.39 230.3 288.44 230.3 272.44 204.96 285.39 204.96 301.39 230.3",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.39,230.8H288.44a.5.5,0,0,1-.42-.23l-16-25.34a.49.49,0,0,1,0-.51.48.48,0,0,1,.43-.26h12.95a.5.5,0,0,1,.42.23l16,25.35a.5.5,0,0,1,0,.5A.51.51,0,0,1,301.39,230.8Zm-12.67-1h11.77l-15.37-24.34H273.35Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.57 230.3 314.63 230.3 298.63 204.96 311.58 204.96 327.57 230.3",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.58,230.8H314.63a.5.5,0,0,1-.42-.23l-16-25.34a.49.49,0,0,1,0-.51.51.51,0,0,1,.44-.26h12.95a.5.5,0,0,1,.42.23L328,230a.5.5,0,0,1-.42.76Zm-12.68-1h11.77L311.3,205.46H299.53Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.67,224.14h-7.88a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h7.88a.5.5,0,0,1,.5.5A.5.5,0,0,1,203.67,224.14Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.19,234.27h-6.76a.5.5,0,0,1-.5-.5.51.51,0,0,1,.5-.5h6.76a.5.5,0,0,1,.5.5A.5.5,0,0,1,168.19,234.27Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.76,211.19H54.44a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5h7.32a.5.5,0,0,1,.5.5A.5.5,0,0,1,61.76,211.19Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.68,250H298.84a.5.5,0,0,1,0-1h29.84a.5.5,0,0,1,0,1Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.68,250H248.34a.5.5,0,0,1,0-1h19.34a.5.5,0,0,1,0,1Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.33,206.68h-5.07a.5.5,0,0,1,0-1h5.07a.5.5,0,0,1,0,1Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.15,222.45h-7.89a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5h7.89a.5.5,0,0,1,.5.5A.51.51,0,0,1,355.15,222.45Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.1,103.45h-9.25a.5.5,0,0,1-.5-.5V91.62a.5.5,0,0,1,.5-.5h9.25a.5.5,0,0,1,.5.5V103A.5.5,0,0,1,231.1,103.45Zm-8.75-1h8.25V92.12h-8.25Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.67,103.45h-9.26a.51.51,0,0,1-.5-.5V91.62a.5.5,0,0,1,.5-.5h9.26a.5.5,0,0,1,.5.5V103A.51.51,0,0,1,250.67,103.45Zm-8.76-1h8.26V92.12h-8.26Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.23,103.45H261a.5.5,0,0,1-.5-.5V91.62a.5.5,0,0,1,.5-.5h9.25a.5.5,0,0,1,.5.5V103A.5.5,0,0,1,270.23,103.45Zm-8.75-1h8.25V92.12h-8.25Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.8,103.45h-9.26a.51.51,0,0,1-.5-.5V91.62a.5.5,0,0,1,.5-.5h9.26a.5.5,0,0,1,.5.5V103A.5.5,0,0,1,289.8,103.45Zm-8.76-1h8.26V92.12H281Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.1,124.61h-9.25a.5.5,0,0,1-.5-.5V112.78a.5.5,0,0,1,.5-.5h9.25a.5.5,0,0,1,.5.5v11.33A.5.5,0,0,1,231.1,124.61Zm-8.75-1h8.25V113.28h-8.25Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.67,124.61h-9.26a.51.51,0,0,1-.5-.5V112.78a.5.5,0,0,1,.5-.5h9.26a.5.5,0,0,1,.5.5v11.33A.51.51,0,0,1,250.67,124.61Zm-8.76-1h8.26V113.28h-8.26Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.23,124.61H261a.5.5,0,0,1-.5-.5V112.78a.5.5,0,0,1,.5-.5h9.25a.5.5,0,0,1,.5.5v11.33A.5.5,0,0,1,270.23,124.61Zm-8.75-1h8.25V113.28h-8.25Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.8,124.61h-9.26a.51.51,0,0,1-.5-.5V112.78a.5.5,0,0,1,.5-.5h9.26a.5.5,0,0,1,.5.5v11.33A.5.5,0,0,1,289.8,124.61Zm-8.76-1h8.26V113.28H281Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.72,132.49h-9.25a.5.5,0,0,1-.5-.5V120.66a.5.5,0,0,1,.5-.5h9.25a.5.5,0,0,1,.5.5V132A.5.5,0,0,1,333.72,132.49Zm-8.75-1h8.25V121.16H325Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.35,176H327.1a.5.5,0,0,1-.5-.5V164.21a.5.5,0,0,1,.5-.5h9.25a.5.5,0,0,1,.5.5v11.33A.5.5,0,0,1,336.35,176Zm-8.75-1h8.25V164.71H327.6Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.33,102.08h-9.25a.5.5,0,0,1-.5-.5V90.26a.5.5,0,0,1,.5-.5h9.25a.5.5,0,0,1,.5.5v11.32A.5.5,0,0,1,321.33,102.08Zm-8.75-1h8.25V90.76h-8.25Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.1,170.42h-9.25a.5.5,0,0,1-.5-.5V158.59a.5.5,0,0,1,.5-.5h9.25a.5.5,0,0,1,.5.5v11.33A.5.5,0,0,1,239.1,170.42Zm-8.75-1h8.25V159.09h-8.25Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.67,170.42h-9.26a.51.51,0,0,1-.5-.5V158.59a.51.51,0,0,1,.5-.5h9.26a.51.51,0,0,1,.5.5v11.33A.51.51,0,0,1,258.67,170.42Zm-8.76-1h8.26V159.09h-8.26Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.53,170.42h-9.25a.5.5,0,0,1-.5-.5V158.59a.5.5,0,0,1,.5-.5h9.25a.5.5,0,0,1,.5.5v11.33A.5.5,0,0,1,219.53,170.42Zm-8.75-1H219V159.09h-8.25Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.23,170.42H269a.5.5,0,0,1-.5-.5V158.59a.5.5,0,0,1,.5-.5h9.25a.5.5,0,0,1,.5.5v11.33A.5.5,0,0,1,278.23,170.42Zm-8.75-1h8.25V159.09h-8.25Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.8,170.42h-9.26a.51.51,0,0,1-.5-.5V158.59a.51.51,0,0,1,.5-.5h9.26a.5.5,0,0,1,.5.5v11.33A.5.5,0,0,1,297.8,170.42Zm-8.76-1h8.26V159.09H289Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.55,232.58h-5.1a.5.5,0,0,1-.5-.5.51.51,0,0,1,.5-.5h5.1a.5.5,0,0,1,.5.5A.5.5,0,0,1,68.55,232.58Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.45,239.9h-5.07a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h5.07a.51.51,0,0,1,.5.5A.5.5,0,0,1,228.45,239.9Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.63,205H220a.5.5,0,0,1,0-1h5.63a.5.5,0,0,1,0,1Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.61,215.13H144a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h5.63a.5.5,0,0,1,.5.5A.5.5,0,0,1,149.61,215.13Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.78,206.68H358a.5.5,0,0,1,0-1h2.82a.5.5,0,0,1,0,1Z",
    fill: "#d1d3d4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstructionSiteFlatline);
export default __webpack_public_path__ + "static/media/construction-site-flatline.2bf75ea53985150dd2bc96991546f648.svg";
export { ForwardRef as ReactComponent };